import React from 'react'
import Header from '../components/common/header/header'
import Banner from '../components/banner/banner'
import NewArticle from '../components/newArticle/newArticle'
import HotArticle from '../components/hotArticle/hotArticle'
import DemandingDetail from '../components/demandingDetail/demandingDetail'
import GetInspired from '../components/getInspired/getInspired'
import Footer from '../components/common/footer/footer'

const LandingPage = () => {
  return (
    <div className='wrapper position-relative'>
      <Header />
      <Banner />
      <NewArticle />
      <HotArticle />
      <DemandingDetail />
      <GetInspired />
      <Footer />
    </div>
  )
}

export default LandingPage